<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    //{
                     // title: 'Dashboard',
                     // url: '/#/dashboard/Trainee/traineeDashboard'
                    //},
                   {
                      title: 'Knowledgebase',
                      url: '/#/dashboard/Trainee/knowledgeBaseRepository'
                    },
                    {
                      title: 'Training Material',
                      url: '/#/dashboard/Trainee/knowledgeBaseRepDetail',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <div class="form-group form-row text-dark">
                <h6 class="sub-frm-title">Event Information</h6>
                <div class="row col-sm-12">
                  <label class="col-sm-1 font-weight-bold">Title:</label>
                  <div class="col-sm-11">{{currentTraining.title}}</div>
                </div>
                <div class="row col-sm-12">
                  <div class="row col-sm-12">
                    <label
                      class="col-sm-2 font-weight-bold"
                      style="padding:0px 0px 0px 15px"
                    >Start Date:</label>
                    <p
                      class="col-sm-2"
                      style="padding:0px 0px 0px 15px"
                    >{{currentTraining.startdate}}</p>

                    <label class="col-sm-2 font-weight-bold p-0">End Date:</label>
                    <p class="col-sm-4 p-0">{{currentTraining.enddate}}</p>
                  </div>
                </div>
              </div>
              <div class="frm-title">
                <div class="heading mt-3">
                  <h3 class="text-secondary">Training Material (Archives)</h3>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="mt-2">
                <b-card no-body style="border:none !important;">
                  <b-tabs pills card vertical>
                    <b-tab :title-item-class="'tab-title-class'" disabled title="Filter by" style></b-tab>
                    <b-tab title="Show All" active>
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="Show All(s)" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in trainingArray"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="Presentations" @click="loadMaterials('PPT')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="Presentation(s)" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(pptfil,index) in PPTFilter"
                                :title="pptfil.title"
                                :subtitle="pptfil.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+pptfil.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="Word" @click="loadMaterials('Word')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="Word Documents" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in WordFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="PDF" @click="loadMaterials('PDF')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="PDF" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in PDFFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="Html Links" @click="loadMaterials('Html')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="Html Links" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in HtmlFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="Videos" @click="loadMaterials('Video')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <div class="row mb-3">
                                <div
                                  class="col-lg-4 mb-1"
                                  v-for="(training,index) in VideosFilter"
                                  v-bind:key="index"
                                >
                                  <!-- video player starts -->
                                  <div class="vd-crd">
                                    <video controls>
                                      <source :src="BASEPATHDYNAMIC+'/'+training.uploadfile" />
                                      <source :src="BASEPATHDYNAMIC+'/'+training.uploadfile" />Your browser does not support HTML5 video.
                                    </video>
                                    <h6 class="vid-title">{{training.title}}</h6>
                                  </div>
                                  <!-- video player ends -->
                                </div>
                              </div>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab disabled title="Filter by Year"></b-tab>
                    <b-tab title="2019" @click="loadMaterialsYear('2019')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="2019" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in TwoNineFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="2018" @click="loadMaterialsYear('2018')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="2018" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in TwoEightFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="2017" @click="loadMaterialsYear('2017')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="2017" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in TwoSevenFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>

                    <b-tab disabled title="Filter by Type"></b-tab>
                    <b-tab title="Pre Training" @click="loadMaterialsType('Pre Training Form')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="Pre Training" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in PreTrainingFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="In Training" @click="loadMaterialsType('In Training Form')">
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="In Training" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in InTrainingFilter"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab
                      title="Reference Material"
                      @click="loadMaterialsType('Reference Material Form')"
                    >
                      <b-card-text>
                        <div class="col-sm-12">
                          <div class="tab-item">
                            <vs-list>
                              <vs-list-header title="Reference Material" color="success"></vs-list-header>
                              <vs-list-item
                                v-for="(training,index) in ReferenceMaterial"
                                :title="training.title"
                                :subtitle="training.createdAt | formatDate"
                                class="hvr"
                                v-bind:key="index"
                              >
                                <a :href="BASEPATHDYNAMIC+'/'+training.uploadfile" target="_blank">
                                  <i
                                    class="material-icons"
                                    style="font-size:28px;color:#4285f4"
                                  >get_app</i>
                                </a>
                              </vs-list-item>
                            </vs-list>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
                <!-- <vs-pagination :total="30" v-model="currentx"></vs-pagination> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import MainSidebar from "./main-sidebar";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
export default {
  data: () => ({
    index: null,
    trainingId: "",
    trainingCode: "",
    BASEPATHDYNAMIC: "",
    PPTFilter: [],
    trainingArray: [],
    filterResult: [],
    isSidebar: false,
    active: false,
    currentx: 30,
    showImgFilter: false,
    showPresFilter: true,
    WordFilter: [],
    PDFFilter: [],
    HtmlFilter: [],
    VideosFilter: [],
    TwoNineFilter: [],
    TwoEightFilter: [],
    TwoSevenFilter: [],
    PreTrainingFilter: [],
    InTrainingFilter: [],
    ReferenceMaterial: [],
    currentTraining: ""
  }),
  components: {
    "app-navbar": Navbar,
    "app-main-sidebar": MainSidebar
  },
  created() {
    this.trainingCode = this.$route.query.training;
    this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingId = response.data.training.id;
        this.currentTraining = response.data.training;
        this.trainingMaterialsLoad();
      });
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    trainingMaterialsLoad: function trainingMaterialsLoad() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainingmaterils/knowledgebase/get/" +
            this.trainingId +
            ""
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainingArray = response.data;
        });
    },
    loadMaterials(type) {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainingmaterils/type/get/" +
            type +
            "" +
            "/" +
            this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (type === "Word") {
            this.WordFilter = response.data;
          } else if (type === "PDF") {
            this.PDFFilter = response.data;
          } else if (type === "Html") {
            this.HtmlFilter = response.data;
          } else if (type === "Video") {
            this.VideosFilter = response.data;
          } else if (type === "PPT") {
            this.PPTFilter = response.data;
          }
        });
    },
    loadMaterialsType(materialType) {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainingmaterils/uploadtype/get/" +
            materialType +
            "" +
            "/" +
            this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (materialType === "Pre Training Form") {
            this.PreTrainingFilter = response.data;
          } else if (materialType === "In Training Form") {
            this.InTrainingFilter = response.data;
          } else if (materialType === "Reference Material Form") {
            this.ReferenceMaterial = response.data;
          }
        });
    },
    loadMaterialsYear(Year) {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/trainingmaterils/uploadyear/get/" +
            Year +
            "" +
            "/" +
            this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (Year === "2019") {
            this.TwoNineFilter = response.data;
          } else if (Year === "2018") {
            this.TwoEightFilter = response.data;
          } else if (Year === "2017") {
            this.TwoSevenFilter = response.data;
          }
        });
    },
    showImg() {
      this.showImgFilter = true;
      this.showPresFilter = false;
    }
  }
};
</script>

<style>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.vs-sidebar.vs-sidebar-primary.vs-sidebar-parent {
  height: 100% !important;
  padding-left: 10px;
  border-right: 1px solid #d4d4d487;
}

.vs-sidebar-parent {
  border-right: 1px solid #d4d4d487 !important;
}

.vs-pagination--ul {
  margin-top: 15px;
}
</style>  

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.vs-list {
  height: 490px !important;
  max-height: 490px !important;
}
.hvr:hover {
  -webkit-transform: translateY(-4px);
  transform: translateY(-4px);
  -webkit-box-shadow: 0 3px 10px 0 #ccc;
  box-shadow: 0 3px 10px 0 #ccc;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.card-body {
  padding: 0px !important;
}

.tab-item {
  background: white;
  border: 1px #d5dadf solid;
  border-left: 1px solid #d5dadf;
  box-shadow: 0 2px 3px rgba(213, 218, 223, 0.35);
  padding: 15px;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 15px;
}

.tab-item:hover,
.tab-item.active {
  box-shadow: 0px 3px 3px 2px rgba(213, 218, 223, 0.35);
  border-left: 1px solid #009ad2;
}

.tab-item__heading {
  font-weight: bold;
  font-size: 18px;
  line-height: 1.3em;
  letter-spacing: 0.02em;
  color: #6c757d;
  margin: 0px;
}

.tab-item__subheading {
  font-size: 15px;
  color: #6c757d;
  margin: 0px;
}
</style>


